export const T = {
  en_GB: {
    suitabilityNoExperience: (productType: string) => `No experience with ${productType}`,
    suitabilityAssessmentNotPassed: (productType: string) =>
      `Assessment for ${productType} not passed`,
    suitabilityThisProductType: "this product type",
    suitabilityRiskTooLow: "Requires higher risk tolerance",
    suitabilityRiskTooLowWithMin: (min: string) => `Requires higher risk tolerance (min: ${min})`,
    suitabilityTimeHorizonTooShort: "Requires longer time horizon",
    suitabilityTimeHorizonTooShortWithMin: (min: string) =>
      `Requires longer time horizon (min: ${min})`,
    suitabilityRiskScoreTooLow: (min: string) => `Client's risk score is too low (min: ${min})`,
  },
  nb_NO: {
    suitabilityNoExperience: (productType: string) => `Ingen erfaring med ${productType}`,
    suitabilityAssessmentNotPassed: (productType: string) =>
      `Vurdering for ${productType} ikke bestått`,
    suitabilityThisProductType: "denne produkttypen",
    suitabilityRiskTooLow: "Krever høyere risikotoleranse",
    suitabilityRiskTooLowWithMin: (min: string) => `Krever høyere risikotoleranse (min: ${min})`,
    suitabilityTimeHorizonTooShort: "Krever lengre tidshorisont",
    suitabilityTimeHorizonTooShortWithMin: (min: string) =>
      `Krever lengre tidshorisont (min: ${min})`,
    suitabilityRiskScoreTooLow: (min: string) => `Kundens risikoscore er for lav (min: ${min})`,
  },
} as const;
